import type { TaskAggregateGroupBy } from "@gw/shared-types";
import { GROUP_LABEL_BY_KEY } from "./GroupByChips";

interface Props {
  drillKeys: TaskAggregateGroupBy[];
  drillVals: string[];
  onClear: () => void;
}

export function DrillChips({ drillKeys, drillVals, onClear }: Props) {
  if (drillKeys.length === 0) return null;
  return (
    <div className="chip-row" style={{ padding: "8px 12px", borderBottom: "1px solid var(--border-subtle)" }}>
      <span
        style={{
          fontSize: 11,
          color: "var(--fg-2)",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          fontWeight: 600,
        }}
      >
        Drill-down:
      </span>
      {drillKeys.map((k, i) => (
        <span key={i} className="chip">
          {GROUP_LABEL_BY_KEY[k]}: {drillVals[i]}
        </span>
      ))}
      <span className="chip clear-all" onClick={onClear}>
        Clear drill-down
      </span>
    </div>
  );
}
